import { apiSlice } from './apiSlice';
import { STOCKS_URL } from '../constants';

export const stocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new stock
    createStock: builder.mutation({
      query: (stock) => ({
        url: STOCKS_URL,
        method: 'POST',
        body: stock,
      }),
    }),

    // Get stock details by ID
    getStockDetails: builder.query({
      query: (id) => ({
        url: `${STOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's stocks
    getMyStocks: builder.query({
      query: () => ({
        url: `${STOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all stocks (Admin)
    getStocks: builder.query({
      query: () => ({
        url: STOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark stock as delivered
    deliverStock: builder.mutation({
      query: (stockId) => ({
        url: `${STOCKS_URL}/${stockId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete stock
    deleteStock: builder.mutation({
      query: (stockId) => ({
        url: `${STOCKS_URL}/${stockId}`,
        method: 'DELETE',
      }),
    }),

    // Delete specific stock items
    deleteStockItems: builder.mutation({
      query: ({ stockId, stockItemsIndexes }) => ({
        url: `${STOCKS_URL}/${stockId}/delete-items`,
        method: 'PUT',
        body: { stockItemsIndexes },
      }),
    }),

    // Update stock
    updateStock: builder.mutation({
      query: ({ stockId, ...body }) => ({
        url: `${STOCKS_URL}/${stockId}`,
        method: 'PUT',
        body,
      }),
    }),

    // ⭐ NEW: Fix missing product IDs (admin)
    fixMissingProductIds: builder.mutation({
      query: () => ({
        url: `${STOCKS_URL}/fix-missing-ids`,
        method: 'PUT',
      }),
    }),

    // ⭐ NEW: Repair ALL stocks (admin)
    repairAllStocks: builder.mutation({
      query: () => ({
        url: `${STOCKS_URL}/repair-all`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useCreateStockMutation,
  useGetStockDetailsQuery,
  useGetMyStocksQuery,
  useGetStocksQuery,
  useDeliverStockMutation,
  useDeleteStockMutation,
  useDeleteStockItemsMutation,
  useUpdateStockMutation,
  useFixMissingProductIdsMutation,   // ⭐ NEW
  useRepairAllStocksMutation,         // ⭐ NEW
} = stocksApiSlice;
